export const ZohoCRMHealthCheckNotificationsType = {
  ZOHO_CRM_FIELDS_SYNC_ERROR: 'ZOHO_CRM_FIELDS_SYNC_ERROR',
  ZOHO_CRM_FIELDS_SYNC_WARNING: 'ZOHO_CRM_FIELDS_SYNC_WARNING',

  ZOHO_CRM_LAYOUTS_SYNC_ERROR: 'ZOHO_CRM_LAYOUTS_SYNC_ERROR',
  ZOHO_CRM_LAYOUTS_SYNC_WARNING: 'ZOHO_CRM_LAYOUTS_SYNC_WARNING',
};

export const ZohoCRMHealthCheckNotificationsWithCriticalSeverityLevel: string[] =
  [
    ZohoCRMHealthCheckNotificationsType.ZOHO_CRM_FIELDS_SYNC_ERROR,
    ZohoCRMHealthCheckNotificationsType.ZOHO_CRM_LAYOUTS_SYNC_ERROR,
  ];

export type ZohoCRMHealthCheckNotificationsTypeValues =
  (typeof ZohoCRMHealthCheckNotificationsType)[keyof typeof ZohoCRMHealthCheckNotificationsType];
